import * as React from 'react';
import { deliveryTypeStore } from '../../store/deliveryTypeStore';
import { DELIVERY_TYPE } from 'src/constants/deliveryTypes';
import { DEBOUNCE_TIME } from 'src/constants/main';
import { debounce } from 'src/utils/perfomance';
import DropDownOption from 'src/view/components/Controls/Pickers/components/DropDownOption/DropDownOption';
import SearchInput from 'src/view/components/Controls/SearchInput/SearchInput';
import './style.scss';

interface IBranchSearchBoxState {
  search: string | undefined;
  loading: boolean;
  autocompleteList?: string[];
  visible: boolean;
}

export default class BranchSearchBox extends React.Component<{}, IBranchSearchBoxState> {
  state: IBranchSearchBoxState = {
    search: deliveryTypeStore.selectedDeliveryState[DELIVERY_TYPE.DELIVERY].location?.address || '',
    loading: false,
    autocompleteList: undefined,
    visible: false,
  };

  changeListVisibility = (visible: boolean) => {
    this.setState({ visible: Boolean(visible) });
  };

  onPlacesChanged = (place: google.maps.places.PlaceResult) => {
    const [lat, lng, address] = [place.geometry?.location?.lat(), place.geometry?.location?.lng(), place.formatted_address];
    if (lat && lng && address) {
      this.setState({ search: address });
      deliveryTypeStore.getDeliveryDependencies(lat, lng);
      this.changeListVisibility(false);
    }
  };

  onPlaceSelect = (address: string) => {
    const placesService: HTMLElement | null = document.getElementById('place-service');
    if (placesService) {
      this.setState({ loading: true });
      const place = new google.maps.places.PlacesService(placesService as HTMLDivElement);
      place.findPlaceFromQuery({ fields: ['formatted_address', 'geometry'], query: address }, (a) => {
        if (!a?.length) {
          this.setState({ loading: false });
        } else {
          this.setState({ loading: false }, () => this.onPlacesChanged(a[0]));
        }
      });
    }
  };

  submitForm = (event: React.FormEvent) => {
    event.preventDefault();
    if (this.state.autocompleteList?.length) {
      this.onPlaceSelect(this.state.autocompleteList[0]);
    }
  };

  getPlaces = () => {
    if (!this.state.search) {
      this.setState({ loading: false, autocompleteList: [] });
      return;
    }
    this.setState({ loading: true });
    const autocompleteService = new google.maps.places.AutocompleteService();
    autocompleteService.getPlacePredictions({ input: this.state.search || '' }, (a: any) => {
      if (!a?.length) {
        this.setState({ autocompleteList: [], loading: false });
        return;
      }
      this.setState({ autocompleteList: a.map((place: any) => place.description), loading: false, visible: true });
    });
  };
  places = debounce(this.getPlaces, DEBOUNCE_TIME.LARGE);

  onSearch = (search: string) => {
    this.setState({ search }, this.places);
  };

  renderPlace = (address: string, index?: number) => {
    return (
      <DropDownOption<string> key={address + '-' + String(index)} value={address} onClick={this.onPlaceSelect}>
        <span className="text-size-16 family-semibold">{address}</span>
      </DropDownOption>
    );
  };

  public render() {
    return (
      <form
        onSubmit={this.submitForm}
        onFocus={() => this.changeListVisibility(true)}
        onBlur={() => this.changeListVisibility}
        className="branches-searchbox flex-grow-1"
      >
        <div id="place-service"></div>
        <SearchInput
          value={this.state.search}
          placeholder="txt_search_address"
          onChangeText={this.onSearch}
          inputClassName="branches-searchbox__input family-medium text-size-16"
          className="full-height"
          loading={this.state.loading}
          customPlaceholder
          withResetIcon
        />
        {this.state.autocompleteList?.length && this.state.visible ? (
          <>
            <div className="branches-searchbox__list scrollable-block__scroll_normal animate__faster animate__animated animate__fadeInRight mt-3">
              {this.state.autocompleteList.map((place, index) => this.renderPlace(place, index))}
            </div>
          </>
        ) : null}
      </form>
    );
  }
}
